import axios, { type AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { getAccessToken  } from './authService';
import { useAccountStore } from '@/stores';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});


instance.interceptors.request.use(async (config) => {
  const accountStore = useAccountStore();

  let accessToken: string | null = '';

    try {
      accessToken = await getAccessToken();
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;

        if (accountStore.hasCurrentAccount) {
          config.headers['X-Account-Id'] = accountStore.currentId!.toString();
        }
      }
    } catch {
      // Could not get access token; request will not be authenticated
    }

  return config;
});

instance.interceptors.response.use((response: AxiosResponse) => {
  return response;
},
(error: AxiosError) => {
  console.error(error);
  throw error;
});

const Api = {
  get(url: string, params?: any, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    if (params) {
      const searchParams = new URLSearchParams(params);
      url = `${url}?${searchParams.toString()}`;
    }

    return instance.get(url, config);
  },

  findById(resource: string, id: number, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return instance.get(`${resource}/${id}`, config);
  },

  post(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return instance.post(url, data, config);
  },
  put(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return instance.put(url, data, config);
  },
  delete(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> {
    return instance.delete(url, config);
  },

  isNotFoundError(error: any): boolean {
    return axios.isAxiosError(error) && error.response?.status === 404;
  },
  isBadRequestError(error: any): boolean {
    return axios.isAxiosError(error) && error.response?.status === 400;
  },
};

export default Api;
